/**
 * The Friday corner — one framed panel from the 1995 movie, parked at the
 * foot of the side navigation.
 *
 * It belongs to the OG Friday world, so it only renders under that theme:
 * the other themes get the app, this one gets the joke.
 */

import { useTheme } from '@/features/theme/ThemeProvider'

import heroCraig from '@/assets/landing/hero-craig.jpg'
import boomboxSticker from '@/assets/landing/boombox-sticker.png'

interface FridayCornerProps {
  /** Hide it when the side navigation is collapsed to the icon rail. */
  hidden?: boolean
}

export function FridayCorner({ hidden = false }: FridayCornerProps) {
  const { theme } = useTheme()
  if (theme.id !== 'pulp' || hidden) return null

  return (
    <figure className="friday-corner">
      <div className="friday-corner__frame">
        <img
          src={heroCraig}
          alt="A man in a yellow hoodie sitting on his porch steps with a boombox."
          width={1100}
          height={1482}
          loading="lazy"
        />
      </div>
      <figcaption className="friday-corner__caption">
        A lot can go down between Thursday and Saturday.
      </figcaption>
      <img
        className="friday-corner__sticker"
        src={boomboxSticker}
        alt=""
        width={700}
        height={646}
        loading="lazy"
      />
    </figure>
  )
}
